import { render, staticRenderFns } from "./FontFamily.vue?vue&type=template&id=0404ffaa&"
import script from "./FontFamily.vue?vue&type=script&lang=js&"
export * from "./FontFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports